module.exports = __webpack_public_path__ + "img/zhengshu.742c9bef.png";